import React from 'react'
import { Box } from '@mui/joy';
import HeaderTwo from '../../component/header/HeaderTwo';
import Breadcrumb from '../../component/common/Breadcrumb';
import FundiActiveJob from '../../blocks/fundi/FundiActiveJob';



const FundiActiveJobPage = () => {
    return (
        <>
           <Box
                   sx={{
                     width:'100%',
                     padding: '0',
                     backgroundColor: '#fff',
                     boxSizing: 'border-box',
           
                   }}
                 >
                <HeaderTwo />
                {/* Home > Job > Active Job */}
                <Breadcrumb parent='Home' title='Job' title1='Active Job' />
                <FundiActiveJob/>
            </Box>
        </>
    )
}

export default FundiActiveJobPage;